var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 11V18H2V4H7.02C7.07 3.29 7.24 2.62 7.5 2H2C0.9 2 0 2.9 0 4V18C0 19.1 0.9 20 2 20H16C17.1 20 18 19.1 18 18V13L16 11ZM14.5 16H3.5L6.25 12.47L8.21 14.83L10.96 11.29L14.5 16ZM17.3 6.89C17.74 6.19 18 5.38 18 4.5C18 2.01 15.99 0 13.5 0C11.01 0 9 2.01 9 4.5C9 6.99 11.01 9 13.49 9C14.37 9 15.19 8.74 15.88 8.3L19 11.42L20.42 10L17.3 6.89ZM13.5 7C12.12 7 11 5.88 11 4.5C11 3.12 12.12 2 13.5 2C14.88 2 16 3.12 16 4.5C16 5.88 14.88 7 13.5 7Z",
    fill: "#FDFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.658fea1eba29db97097c1d7428cb6e55.svg";
export { ForwardRef as ReactComponent };